var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 21.5,
    viewBox: "0 0 17.5 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Voice-2",
    "data-name": "Iconly/Light-Outline/Voice-2",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Voice-2",
    transform: "translate(3 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M16.75,8.8a.75.75,0,0,1,.75.75,8.785,8.785,0,0,1-8,8.756V20.75a.75.75,0,0,1-1.5,0V18.307A8.785,8.785,0,0,1,0,9.551a.75.75,0,0,1,1.5,0,7.25,7.25,0,1,0,14.5,0A.75.75,0,0,1,16.75,8.8ZM8.75,0a4.826,4.826,0,0,1,4.811,4.831V9.519a4.812,4.812,0,1,1-9.623,0V4.831A4.827,4.827,0,0,1,8.75,0Zm0,1.5A3.325,3.325,0,0,0,5.438,4.831V9.519a3.311,3.311,0,0,0,6.622.075H9.821a.75.75,0,0,1,0-1.5h2.24V6.255H10.819a.75.75,0,0,1,0-1.5h1.239l0-.113A3.323,3.323,0,0,0,8.75,1.5Z",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.016e9f2e.svg";
export { ForwardRef as ReactComponent };